import React from "react";
import "../../assets/styles/Loader.css"; 

export default function FullPageLoader({ loadingName }) {
  const appName = loadingName || "SYSTEM CORE"; // اسم التطبيق الافتراضي

  return (
    <div className="advanced-loader-container">
      {/* 1. حلقة المذنب (زي ما هي عشان عجبتك) */}
      <div className="comet-ring">
        <div className="ring-inner"></div>
      </div>
      
      {/* 2. منطقة النص المتطور */}
      <div className="text-content-wrapper">
        {/* اسم التطبيق اللي بينبض بالطاقة */}
        <h2 className="holographic-text" data-text={appName}>
          {appName}
        </h2>
        
        {/* سطر حالة صغير تحته */}
        <div className="status-line">
          <span className="status-dot"></span>
          <p className="status-text">Initializing processes...</p>
        </div>
      </div>
    </div>
  );
}